<template>
  <div class="g-layout">
    <header id="header" data-domain="" data-domainen="//www.cgtn.com"  data-domainui="//espanol-static.cgtn.com">
      <div class="desktop-header">
        <div class="header-top">
          <div class="cg-mainWrapper">
            <div class="header-top-left J_header-top-left">
              <span class="slogan">Bienvenido al canal en español</span>
            </div>
            <a href="" class="header-top-logo">
              <img src="https://espanol-static.cgtn.com/w/images/icon/logo@3x.png" alt="">
            </a>
            <div class="header-top-right">
              <div class="clearfix follow-us J_follow-us">
                <div class="list J_list">
                </div>
                <img src="https://espanol-static.cgtn.com/w/images/header/qrcode.png" alt="" class="qr-code J_qr-code">
              </div>
              <div class="tools clearfix">
                <div class="clearfix search J_header-search">
                  <input type="text" class="input J_input">
                  <a href="javascript:void(0);" class="btn J_btn">
                    <img src="https://espanol-static.cgtn.com/w/images/header_icon/home_search_white.png" alt="">
                  </a>
                </div>
                <div class="media J_header-media">
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="header-nav J_header-nav">
          <div class="cg-mainWrapper list J_list">
          </div>
        </div>
      </div>

      <div class="mobile-header">
        <div class="header-top JM_header-top">
          <a href="javascript:void(0);" class="icon more J_more"></a>
          <a href="" class="logo">
            <img src="//espanol-static.cgtn.com/w/images/icon/logo@3x.png" alt="">
          </a>
          <a href="javascript:void(0);" class="icon search JM_header-search">
            <img src="//espanol-static.cgtn.com/w/images/header_icon/home_search_white.png" alt="">
          </a>
        </div>
        <div class="header-content JM_header-content">
          <div class="nav JM_header-nav">
          </div>
          <div class="clearfix follow-us JM_follow-us">
          </div>
        </div>
        <div class="header-qr-code JM_header-qr-code">
          <img src="//espanol-static.cgtn.com/w/images/header/qrcode.png" alt="" class="image">
        </div>
      </div>
    </header>
    <slot></slot>
    <footer class="main-footer">
      <div class="cg-mainWrapper wrapper">
        <div class="clearfix footer-top">
          <a href="" class="logo">
            <img src="https://espanol-static.cgtn.com/w/images/icon/logo@3x.png" alt="">
          </a>
          <img src="https://espanol-static.cgtn.com/w/images/header_icon/cgtn_slogan_blue.png" alt="" class="slogan">
        </div>
        <div class="clearfix footer-content">
          <div class="footer-nav">
            <p class="title">MAPA WEB</p>
            <ul class="clearfix list  J_footer-nav">

            </ul>
          </div>
          <div class="footer-channel J_footer-channel">
            <p class="title">EXPLORAR MÁS</p>
            <ul class="clearfix list customList J_list">
              <!-- <li><a href="" style="color: rgba(255,255,255,.6)">English</a></li> -->
              <!-- <li><a href="" style="color: rgba(255,255,255,.6)">English</a></li> -->
            </ul>
          </div>
          <div class="footer-app J_footer-app">
            <p class="title">DESCARGAR LA APLICACIÓN DE CGTN</p>
            <ul class="clearfix list J_list">

            </ul>
            <p class="title">DESCARGAR LA APLICACIÓN DE ES CHINA</p>
            <ul class="clearfix list J_list_2">

            </ul>
          </div>
        </div>
        <div class="clearfix footer-bottom J_footer-bottom">
          <p class="copyright">Copyright © 2020 CGTN. Beijing ICP prepared NO.16065310-3</p>
          <ul class="list J_list">

          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: '',

  data () {
    return {
      //
  }
},

  methods: {
    //
  },

  mounted () {
    //
  }
}
</script>

<style lang='less' scoped>
.customList{
  li{
    width: 33.33%;
    padding-bottom: 15px;
    float: left;
    .text{
      color: rgba(255,255,255,.6);
    }
  }
}
@media screen and (max-width: 1279px) {
  .customList{
  li{
    width: 100%;
    padding-bottom: 15px;
    .text{
      color: rgba(255,255,255,.6);
    }
  }
}
}
</style>